import React, { ReactNode } from 'react';
import './toolbar.css';

export enum Direction {
    Vertical,
    Horizontal
};


type Props = {
    direction? : Direction; 
    children?  : ReactNode;
};

export class ToolBar extends React.Component<Props> 
{

    getClasses() : string
    {
        if (this.props.direction === undefined || this.props.direction === Direction.Vertical) {
            return "toolbar vertical";
        }
        else {
            return "toolbar horizontal";
        }
    }

    render() {
        return (
            <div className={ this.getClasses() }>
                {this.props.children}
            </div>
        );
    }
}

